<template>
  <div class="upload-file-list">
    <upload-attach v-if="canUpload" @uploaded="uploadedFile"></upload-attach>
    <new-table class="file-table" ref="tableRef" :data="attachFiles" :columns="attachColumns" />
  </div>
</template>
<script>
import NewTable from "@/components/new-table.vue";
import { downloadWithUrl, FileSize } from "@/utils/util";
import UploadAttach from "@/views/components/upload-attach";
export default {
  name: "upload-file-list",
  props: {
    attachList: Array,
    canUpload: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      attachColumns: [
        { label: "文件名称", prop: "fileName" },
        { label: "附件大小", render: (h, { row }) => FileSize(row.fileSize) },
        { label: "上传人", prop: "uploadUserName" },
        { label: "上传时间", prop: "creationTime", width: "135px" },
        { label: "来源", prop: "fileSource" },
        {
          label: "操作",
          width: "100px",
          render: (h, { row, $index }) => (
            <span>
              <el-button type="text" onClick={() => this.download(row, $index)}>
                下载
              </el-button>
              {this.canDelete && (
                <el-button type="text" class="red-text-btn" onClick={() => this.deleAttach(row, $index)}>
                  删除
                </el-button>
              )}
            </span>
          ),
        },
      ],
      isShowingMsg: false,
    };
  },
  computed: {
    attachFiles() {
      return this.attachList.filter((i) => !i.isDelete);
    },
  },
  methods: {
    uploadedFile(file) {
      this.attachList.push(file);
      this.debangce();
    },
    debangce() {
      if (!this.isShowingMsg) {
        this.$message.success("上传成功");
        this.isShowingMsg = true;
        setTimeout(() => {
          this.isShowingMsg = false;
        }, 3000);
      }
    },
    download(row) {
      downloadWithUrl(`${this.$ossUrl}${row.filePath}`, row.fileName);
    },
    deleAttach(row, index) {
      if (row.id) {
        this.$set(row, "isDelete", 1);
      } else {
        this.attachList.splice(index, 1);
      }
    },
  },
  components: { NewTable, UploadAttach },
};
</script>
<style scoped lang="scss">
.file-table {
  border: 1px solid #dcdfe6;
  height: 200px;
}
</style>
